module.exports = __webpack_public_path__ + "media/images/star-pattern-a1e1a12085a7d663e3706bc9a675df54.png";